import { ActionPillVariant } from '@components/ActionStatusPill/enums';
import { StatusIconType } from '@components/StatusIcon/enums';
import { Translate } from '@hooks/useI18n';

export const getStatus = (isSuccess: boolean | undefined) =>
  isSuccess ? StatusIconType.Success : StatusIconType.Error;

export const getPillVariant = (isSuccess: boolean | undefined) =>
  isSuccess ? ActionPillVariant.Success : ActionPillVariant.Error;

export const getPillLabel = (
  isSuccess: boolean | undefined,
  translate: Translate,
) => (isSuccess ? translate('STATUS.COMPLETE') : translate('STATUS.REQUIRED'));
